module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Combat skill":"Combat skill","Endurance":"Endurance"},"fr":{"Combat skill":"Habileté","Endurance":"Endurance"}}')
  delete Component.options._Ctor
}
